import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../../assets/icons/map-marker-alt-solid.svg'


const _withScopeId = n => (_pushScopeId("data-v-1b3bec69"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-lg-6 order-1 px-0" }
const _hoisted_3 = { class: "project-image-container" }
const _hoisted_4 = { class: "col-12 col-lg-6 order-2 project-name-container" }
const _hoisted_5 = { class: "d-flex flex-column flex-lg-row" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "project-name-spacer-start" }, null, -1))
const _hoisted_7 = { class: "project-name ps-5 ps-lg-0" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "desc" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-none d-lg-block project-name-spacer-end" }, null, -1))
const _hoisted_11 = {
  key: 0,
  class: "project-location"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-none d-lg-block spacer" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "location-hr ms-5 ms-lg-0" }, null, -1))
const _hoisted_14 = { class: "d-flex flex-row align-items-center" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "location-icon",
  src: _imports_0
}, null, -1))
const _hoisted_16 = {
  key: 0,
  class: "location-text"
}
const _hoisted_17 = {
  key: 1,
  class: "location-text"
}
const _hoisted_18 = {
  key: 2,
  class: "location-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageContainer = _resolveComponent("ImageContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ImageContainer, { imageUrl: _ctx.coverImageUrl }, null, 8, ["imageUrl"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.portfolio.name), 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.portfolio.shortDesc), 1)
        ]),
        _hoisted_10
      ]),
      (_ctx.portfolio.location)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _hoisted_12,
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              (_ctx.portfolio.location.area && _ctx.portfolio.location.city)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.portfolio.location.area + ', ' + _ctx.portfolio.location.city), 1))
                : _createCommentVNode("", true),
              (!_ctx.portfolio.location.city && _ctx.portfolio.location.area)
                ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.portfolio.location.area), 1))
                : _createCommentVNode("", true),
              (_ctx.portfolio.location.city && !_ctx.portfolio.location.area)
                ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.portfolio.location.city), 1))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}